import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ExcelValidationService } from '../../services/excel-validation.service';
import { AgencyReportConstants } from '../../../Common/Constants/data';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnChanges {
  //  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  @Input() allowMultiple: boolean = false;
  @Input() allowedFileTypes: string = '';
  @Input() agencyId: number = 0;
  @Input() agencyName: string = '';

  @Output() filesChanged = new EventEmitter<Array<{ name: string, base64: string }>>();

  files: Array<{ name: string, base64: string }> = [];
  fileInputId: string = 'file-input';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['allowMultiple']) {
      this.updateFileInputAttributes();
    }
  }

  constructor(private excelValidationService: ExcelValidationService) { }

  triggerFileInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onFilesSelected(event: any) {
    const selectedFiles = event.target.files;
    this.files = [];

    if (this.allowMultiple) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        this.convertToBase64(file).then(base64 => {
          this.files.push({ name: file.name, base64: base64 });
          if (i === selectedFiles.length - 1) {
            this.filesChanged.emit(this.files);
          }
        });
      }
    } else {

      const { sheetName, requiredColumns } = AgencyReportConstants.getAgencyConstants(this.agencyName);

      if (sheetName == '') {
        this.files = [{ name: 'Invalid', base64: '' }];
        this.filesChanged.emit(this.files);
        this.resetFileInput();
        return;
      }

      const file = selectedFiles[0];
      if (file) {

        const fileSizeInMB = file.size / (1024 * 1024);

        //Max File Size - 100 MB
        if (fileSizeInMB > 100) {
          this.files = [{ name: 'Invalid', base64: '' }];
          this.filesChanged.emit(this.files);
          this.resetFileInput();
          return;
        }

        this.excelValidationService.validateFile(file, sheetName, requiredColumns)
          .then(isValid => {
            if (isValid) {
              this.convertToBase64(file).then(base64 => {
                this.files = [{ name: file.name, base64: base64 }];
                this.filesChanged.emit(this.files);
                this.resetFileInput();
              });
            } else {
              this.files = [{ name: 'Invalid', base64: '' }];
              this.filesChanged.emit(this.files);
              this.resetFileInput();
            }
          })
          .catch(error => {
            console.error('Error validating file', error);
          });

      }
    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = () => reject('Error reading file');
      reader.readAsDataURL(file);
    });
  }

  private updateFileInputAttributes() {
    const fileInput = document.getElementById(this.fileInputId) as HTMLInputElement;
    if (fileInput) {
      fileInput.multiple = this.allowMultiple;
    }
  }

  private resetFileInput() {
    const fileInput = this.fileInput.nativeElement as HTMLInputElement;
    fileInput.value = '';
  }

}